var _a;
import { ErrorType } from "../types/ErrorType";
/**
 * Translation ids of the backend rejections of title subjects: Thema
 * qualifier without a category (issue #75750) and the main subject rules per
 * scheme (issue #76113). The form validates the same rules, so these only
 * show up when the client-side check was bypassed.
 */
var TITLE_SUBJECT_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.TITLE_SUBJECT_THEMA_QUALIFIER_REQUIRES_CATEGORY] = "ui-br-agency.title.error.subjectThemaQualifierWithoutCategory",
    _a[ErrorType.TITLE_SUBJECT_MAIN_NOT_ALLOWED] = "ui-br-agency.title.error.subjectMainNotAllowed",
    _a[ErrorType.TITLE_SUBJECT_MULTIPLE_MAIN_IN_SCHEME] = "ui-br-agency.title.error.subjectMultipleMainInScheme",
    _a);
/**
 * Maps a backend error type to the message of a rejected title subject.
 *
 * @param code the `type` of the first error of an error response
 * @returns the translation id, or `undefined` for any other error
 */
export var resolveTitleSubjectErrorMessageId = function (code) {
    return code ? TITLE_SUBJECT_ERROR_MESSAGE_IDS[code] : undefined;
};
/**
 * Maps every backend error type of a rejected title to the messages of the
 * rejected subject rules — one response may break several at once.
 *
 * @param codes the `type`s of all errors of an error response
 * @returns the distinct translation ids, in response order
 */
export var resolveTitleSubjectErrorMessageIds = function (codes) {
    return codes
        .map(resolveTitleSubjectErrorMessageId)
        .filter(function (id) { return !!id; })
        // distinct without spreading a Set: the stripes build targets ES5
        .filter(function (id, index, ids) { return ids.indexOf(id) === index; });
};
